<template>
  <div class="detail-coupon-dialog" @touchmove.prevent>
    <div class='mask'></div>
    <div class="coupon-dialog-main">
      <i class="dialog-close-icon iconfont icon-icon_wrong" @click="close"></i>
      <div class="goods-img">
        <img :src="dataInfo.goodsImg" alt="" />
      </div>
      <div class="cdm-text">点击一键复制按钮，复制成功后前往 <i class="iconfont icon-taobao2"></i>「淘宝APP」进行购买</div>
      <div class="ticket-number">
        <input class="txt" type="text" id="couponKeyWords" :value="dataInfo.pwdStr" readonly='true'>
      </div>
      <div class="cdm-btn">
        <span class="tip-text" v-show="hasCopy">{{tipText}}</span>
        <span class="tip-text err" v-show="errFeedback && !hasCopy" @click="priceError">价格出错了？</span>
        <span class="copy-btn" @click="onCopy" v-if="!hasCopy">一键复制</span>
        <template v-else>
          <span class="copy-btn success" v-if="copySuccess">复制成功</span>
          <span class="copy-btn cancel" v-else>复制失败</span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { MessageBox } from 'mint-ui'

export default {
  data () {
    return {
      tipText: '请长按虚线框进行手动复制',
      hasCopy: false,
      copySuccess: true,
      timeout: null,
      time: 3
    }
  },
  props: {
    dataInfo: {
      type: Object,
      require: true,
      default: () => {
        return {}
      }
    },
    errFeedback: {
      type: Boolean,
      default: true
    }
  },
  beforeDestroy () {
    clearTimeout(this.timeout)
  },
  methods: {
    onCopy () {
      this.hasCopy = true
      if (document.execCommand) {
        var shopKeyWords = document.getElementById('couponKeyWords')
        shopKeyWords.focus()
        shopKeyWords.select()
        shopKeyWords.setSelectionRange(0, shopKeyWords.value.length)
        if (document.execCommand('copy', true, null)) {
          this.cutDown()
          this.copySuccess = true
          this.tipText = '前往淘宝APP领券购买'
        } else {
          this.cutDown()
          this.copySuccess = false
          this.tipText = '请长按虚线框进行手动复制'
        }
        document.activeElement.blur()
      } else {
        this.cutDown()
        this.copySuccess = false
        this.tipText = '请长按虚线框进行手动复制'
        MessageBox({
          title: '提示',
          message: '网页不兼容，无法复制',
          confirmButtonText: '知道了',
          confirmButtonClass: 'c000'
        })
      }
    },
    cutDown () {
      if (this.time <= 0) {
        clearTimeout(this.timeout)
        this.time = 3
        this.hasCopy = false
        return
      }
      this.timeout = setTimeout(this.cutDown, 1000)
      this.time--
    },
    close () {
      this.$emit('close')
    },
    // 价格出错
    priceError () {
      this.$emit('priceError')
    }
  }
}
</script>

<style scoped>
  .detail-coupon-dialog{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
  }
  .mask{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 999;
    background: rgba(0, 0, 0, .7);
  }
  .coupon-dialog-main{
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -55%);
    border-radius: 5px;
    box-sizing: border-box;
    width: 88%;
    height: 251px;
    padding: 0 4%;
    background: #fff;
    font-size: 15px;
    animation: opacityAnim 300ms 50ms ease-in-out;
    animation-fill-mode: backwards;
    z-index: 1000;
  }
  .dialog-close-icon{
    position: absolute;
    right: 8px;
    top: 8px;
    font-size: 12px;
    width: 18px;
    height: 18px;
    line-height: 18px;
    border: 2px solid #4E4D51;
    text-align: center;
    border-radius: 50%;
    color: #4E4D51;
  }
  .goods-img{
    display: block;
    position: absolute;
    top: -35px;
    left: 41%;
    width: 70px;
    height: 70px;
    border-radius: 5px;
    box-shadow: 0 2px 5px #999;
    animation: imgBounceAnim 2.5s infinite;
  }
  .goods-img img{
    width: 70px;
    height: 70px;
    border-radius: 5px;
  }
  .cdm-text{
    margin-top: 18%;
    line-height: 20px;
  }
  .cdm-text .iconfont{
    background: #FF730D;
    color: #fff;
    border-radius: 2px;
    padding: 1px;
    font-size: 14px;
  }
  .ticket-number{
    width: 100%;
    height: 28%;
    margin-top: 15px;
    margin-left: -2px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border: 2px dashed #F25C60;
    font-size: 16px;
    font-weight: 500;
    box-sizing: border-box;
    overflow: hidden;
  }
  .ticket-number .txt{
    height: 100%;
    width: 100%;
    text-align: center;
  }
  .cdm-btn{
    position: relative;
    display: flex;
    align-items: center;
    text-align: center;
    margin-top: 15px;
  }
  .cdm-btn .tip-text{
    position: absolute;
    top: 5px;
    left: 0;
    color: #F25C60;
  }
  .cdm-btn .err{
    color: #3fa5ff;
  }
  .cdm-btn .copy-btn{
    position: absolute;
    top: 0;
    right: 0;
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
    text-align: center;
    padding: 0 10px;
    background: #F25C60;
    color: #fff;
    font-size: 14px;
  }
  .cdm-btn .success{
    background: #67c23a;
  }
  .cdm-btn .cancel{
    background: #999;
  }
  @keyframes imgBounceAnim{
    0%, 100% {
      transform: rotate(0deg);
    }
    79% {
      transform: rotate(0deg);
    }
    80% {
      transform: rotate(15deg);
    }
    85% {
      transform: rotate(-15deg);
    }
    90% {
      transform: rotate(5deg);
    }
    95% {
      transform: rotate(-5deg);
    }
  }
</style>
